import type { ArticleDoc } from './doc';

/**
 * Distinct assetIds of the image nodes anywhere in a document — including a
 * truncated gated preview (get_article_render returns 3 paragraphs, so a caller
 * must fetch exactly the assets the returned doc actually contains, not the full
 * body's). Pure, no network.
 */
export function collectAssetIds(doc: ArticleDoc | null | undefined): string[] {
  const ids = new Set<string>();
  const walk = (node: unknown): void => {
    if (!node || typeof node !== 'object') return;
    const n = node as { type?: string; attrs?: { assetId?: unknown }; content?: unknown[] };
    if (n.type === 'image' && typeof n.attrs?.assetId === 'string') ids.add(n.attrs.assetId);
    if (Array.isArray(n.content)) n.content.forEach(walk);
  };
  walk(doc);
  return [...ids];
}
